import { ReactComponent as SvgChevronRight } from '@img/icons/chevron-right.svg';
import React from 'react';
import S from './FeatureCard.styles';
const FeatureCard = ({ centreOnMobile, content, cta, icon, title }) => {
    return (React.createElement(S.Container, { "data-center-m": centreOnMobile },
        icon && React.createElement(S.Icon, { alt: "", draggable: false, loading: "lazy", src: icon }),
        React.createElement(S.Title, null, title),
        content && React.createElement(S.Content, { dangerouslySetInnerHTML: { __html: content } }),
        cta?.text && (React.createElement(S.Link, { "aria-label": cta?.accessibleText, href: cta?.url, target: cta?.target },
            React.createElement("span", null, cta?.text),
            React.createElement(SvgChevronRight, null)))));
};
export default FeatureCard;
